import type { RouteObject } from 'react-router-dom'

import type { NavItem } from '@/app/registry'

import { ImportPage } from './ImportPage'
import { InBodyPage } from './InBodyPage'
import { ScanPage } from './ScanPage'

export const routes: RouteObject[] = [
  { path: '/health/inbody', element: <InBodyPage /> },
  { path: '/health/inbody/import', element: <ImportPage /> },
  { path: '/health/inbody/:id', element: <ScanPage /> },
]

export const nav: NavItem[] = [
  { path: '/health/inbody', label: 'Состав тела', icon: 'target', mobile: null, order: 15, parent: '/health' },
]
